"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRouterDom = require("react-router-dom");

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

var _AppIcon = _interopRequireDefault(require("../ImagesAndIcons/AppIcon"));

var _Icon = _interopRequireDefault(require("../ImagesAndIcons/Icon"));

var _Paragraph = _interopRequireDefault(require("../TitlesAndTexts/Paragraph"));

var _SmallText = _interopRequireDefault(require("../TitlesAndTexts/SmallText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Theme
// Components
const LinkStyled = (0, _styledComponents.default)(_reactRouterDom.Link).withConfig({
  displayName: "AppTableCell__LinkStyled",
  componentId: "design-system__i7ym2t-0"
})(["text-decoration:none;& > div > div:nth-child(2) > p{color:", ";}&:hover > div > div:nth-child(2) > p{text-decoration:underline;}& > div > div:nth-child(2) > aside > small{color:", ";}&:hover p{text-decoration:none;}"], _BaseTheme.default.colors.blue, _BaseTheme.default.colors.gray);

const WrapperStyled = _styledComponents.default.div.withConfig({
  displayName: "AppTableCell__WrapperStyled",
  componentId: "design-system__i7ym2t-1"
})(["display:flex;flex-direction:row;& > div:nth-child(2){display:flex;flex-direction:column;padding-left:1rem;justify-content:center;& > p{line-height:", ";}}& > div > aside{display:flex;& > div{margin-right:0.5rem;}& > div,& > p{line-height:0.85;}}& p{margin:0;}"], _BaseTheme.default.type.lineHeight.normal);

const Wrapper = _ref => {
  let {
    to,
    children
  } = _ref;

  if (to) {
    return /*#__PURE__*/_react.default.createElement(LinkStyled, {
      to: to
    }, /*#__PURE__*/_react.default.createElement(WrapperStyled, null, children));
  }

  return /*#__PURE__*/_react.default.createElement(WrapperStyled, null, children);
};

const AppTableCell = _ref2 => {
  let {
    id,
    name,
    platform,
    smallText,
    to
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    to: to
  }, id && /*#__PURE__*/_react.default.createElement(_AppIcon.default, {
    type: id,
    size: "40"
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Paragraph.default, null, name), (platform || smallText) && /*#__PURE__*/_react.default.createElement("aside", null, platform && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: platform,
    size: "16"
  }), smallText && /*#__PURE__*/_react.default.createElement(_SmallText.default, null, smallText))));
};

Wrapper.propTypes = {
  to: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.func]),
  children: _propTypes.default.node.isRequired
};
Wrapper.defaultProps = {
  to: undefined
};
AppTableCell.propTypes = {
  id: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  platform: _propTypes.default.oneOf(['ios', 'android']),
  smallText: _propTypes.default.string,
  to: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.func])
};
AppTableCell.defaultProps = {
  id: undefined,
  platform: undefined,
  smallText: undefined,
  to: undefined
};
var _default = AppTableCell;
exports.default = _default;